<app-header> </app-header>
<section>
  <div class="block">
    <div class="courseContainer">
      <span class="chip chip--primary mt-4">{{ genrelist.genre }}</span>
      <h1 class="headingBL mt-2 mb-4">
        {{ gettitle(genrelist.name)
        }}<span> {{ gettitle(genrelist.name, true) }}</span>
      </h1>
      <div class="courseDetailContainer d-flex gap-3 align-items-start">
        <div class="d-flex flex-column gap-5">
          <div class="introVideo">
            <div class="introImg" [ngClass]="{ play: display }">
              <div class="position-absolute w-100 d-flex justify-content-center align-items-center h-100 border-1">
                <img (click)="play()" src="assets/images/icons/ic_play.png" alt="play"
                  style="height: 4rem; width: 4rem" />
              </div>
              <img class="imgThum" [src]="genrelist.pic_urls" [alt]="genrelist.name" />
            </div>
            <div class="video-player-container position-relative">
              <video #videoPlayer #demoVideo class="video" [ngClass]="getQualityClass()" controls [src]="getVideoSource()" playsinline webkit-playsinline preload="auto">
                Your Browser Does't Support Video Playback
              </video>

              <!-- Video Quality Overlay Menu -->
              <div class="video-quality-overlay">
                <button
                  type="button"
                  class="quality-toggle-btn d-flex align-items-center gap-1"
                  (click)="toggleQualityMenu($event)"
                  title="Select Video Quality"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-gear-fill" viewBox="0 0 16 16">
                    <path d="M9.405 1.05c-.413-1.4-2.397-1.4-2.81 0l-.1.34a1.464 1.464 0 0 1-2.105.872l-.31-.17c-1.283-.698-2.686.705-1.987 1.987l.169.311c.446.82.023 1.841-.872 2.105l-.34.1c-1.4.413-1.4 2.397 0 2.81l.34.1a1.464 1.464 0 0 1 .872 2.105l-.17.31c-.698 1.283.705 2.686 1.987 1.987l.311-.169a1.464 1.464 0 0 1 2.105.872l.1.34c.413 1.4 2.397 1.4 2.81 0l.1-.34a1.464 1.464 0 0 1 2.105-.872l.31.17c1.283.698 2.686-.705 1.987-1.987l-.169-.311a1.464 1.464 0 0 1 .872-2.105l.34-.1c1.4-.413 1.4-2.397 0-2.81l-.34-.1a1.464 1.464 0 0 1-.872-2.105l.17-.31c.698-1.283-.705-2.686-1.987-1.987l-.311.169a1.464 1.464 0 0 1-2.105-.872zM8 10.93a2.93 2.93 0 1 1 0-5.86 2.93 2.93 0 0 1 0 5.86"/>
                  </svg>
                  <span class="quality-label">{{ selectedQuality }}</span>
                </button>

                <div *ngIf="showQualityMenu" class="quality-dropdown-menu">
                  <div class="quality-header">Quality</div>
                  <button
                    *ngFor="let q of availableQualities"
                    type="button"
                    class="quality-option-btn d-flex align-items-center justify-content-between"
                    [class.active]="selectedQuality === q"
                    (click)="changeQuality(q)"
                  >
                    <span>{{ q }}</span>
                    <svg *ngIf="selectedQuality === q" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
                      <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="cardsContainer gap-4 w-100">
          <div class="descriptionCard w-100">
            <h3>Description</h3>
            <p>
              {{ genrelist.short_description }}
            </p>
          </div>
          <div class="priceCard w-100">
            <div class="d-flex flex-column priceWrap">
              <div class="price">&#8377;{{ genrelist.discount_cost }}</div>
              <div class="discount">
                {{ genrelist.discount }}% Disc
                <span>&#8377;{{ genrelist.original_cost }}</span>
              </div>
              <div class="btnGlobal--secondary buy point" (click)="handleButtonClick()">
                {{
                genrelist.is_purchased && !genrelist.is_course_expired
                ? "Start Learning"
                : "Buy Now"
                }}
              </div>
            </div>
            <div class="d-flex flex-row justify-content-between gap-4 detailWrap">
              <ul>
                <li class="d-flex flex-row gap-2 detailTitle">
                  <img loading="lazy" src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_level.png"
                    alt="ic_level" />
                  <div>Skill Level</div>
                </li>
                <li class="d-flex flex-row gap-2 detailTitle">
                  <img loading="lazy" src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_duration.png"
                    alt="ic_duration" />
                  <div>Duration</div>
                </li>
                <li class="d-flex flex-row gap-2 detailTitle">
                  <img loading="lazy" src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_lesson.png"
                    alt="ic_lesson" />
                  <div>Lessons</div>
                </li>
                <li class="d-flex flex-row gap-2 detailTitle">
                  <img loading="lazy" src="https://d2abnqj5vuy2s4.cloudfront.net/assets/images/icons/ic_certificate.png"
                    alt="ic_certificate" />
                  <div>Certificate</div>
                </li>
              </ul>
              <ul>
                <li class="detailValue">Beginner</li>
                <li class="detailValue">{{ genrelist.total_hrs }} hr</li>
                <li class="detailValue">
                  {{ genrelist.total_lesson }} Lessons
                </li>
                <li class="detailValue">On Complete</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div class="d-flex vWork gap-3">
        <div class="sizeWrapper">
          <div class="row mb-5">
            <div class="a-box">
              <div class="img-container">
                <div class="img-inner">
                  <div class="inner-skew">
                    <img src="assets/images/icons/beignners.png" alt="Beginners Level Icon" />
                  </div>
                </div>
              </div>
              <div class="text-container">
                <h3>Designed for Beginners</h3>
                <div>No Age Barrier, Start at any Age</div>
              </div>
            </div>
            <div class="a-box">
              <div class="img-container">
                <div class="img-inner">
                  <div class="inner-skew">
                    <img src="assets/images/icons/flexible.png" alt="Flexible Learning Icon" />
                  </div>
                </div>
              </div>
              <div class="text-container">
                <h3>Flexible</h3>
                <div>
                  All master classes are avialable post the live class for self
                  learning and regular revision session
                </div>
              </div>
            </div>
            <div class="a-box">
              <div class="img-container">
                <div class="img-inner">
                  <div class="inner-skew">
                    <img src="assets/images/icons/practice.png" alt="Regular Practice Icon" />
                  </div>
                </div>
              </div>
              <div class="text-container">
                <h3>Unlimited Practices</h3>
                <div>
                  After live class, get 24*7 access to practice session for each
                  module
                </div>
              </div>
            </div>
            <div class="a-box">
              <div class="img-container">
                <div class="img-inner">
                  <div class="inner-skew">
                    <img src="assets/images/icons/language.png" alt="Multiple Languages Icon" />
                  </div>
                </div>
              </div>
              <div class="text-container">
                <h3>Choose Your Language</h3>
                <div>Live Classes in English & Hindi</div>
              </div>
            </div>
          </div>
          <div class="tabContainer">
            <mat-tab-group>
              <mat-tab label="About Course">
                <div class="aboutCourse p-3">
                  <h3>About This Course</h3>
                  <p>
                    {{ genrelist.description }}
                  </p>
                </div>
                <h3 class="mb-4">How VIRSA Work?</h3>
                <div class="d-flex gap-4 vWork">
                  <div class="descriptionCard d-flex flex-column align-items-center">
                    <img class="vWorkicon" src="assets/images/icons/ic-1.png" alt="Step 1 Icon" />
                    <h5 class="cardTitile">Pick Your Passion</h5>
                  </div>
                  <div class="descriptionCard d-flex flex-column align-items-center">
                    <h5 class="cardTitile">Interact With an Expert</h5>
                    <img class="vWorkicon" src="assets/images/icons/ic-2.png" alt="" />
                  </div>
                  <div class="descriptionCard d-flex flex-column align-items-center">
                    <img class="vWorkicon" src="assets/images/icons/ic-3.png" alt="" />
                    <h5 class="cardTitile">Set Session Schedules</h5>
                  </div>
                  <div class="descriptionCard d-flex flex-column align-items-center">
                    <h5 class="cardTitile">Pay as You Go</h5>
                    <img class="vWorkicon" src="assets/images/icons/ic-4.png" alt="" />
                  </div>
                </div>
              </mat-tab>
              <mat-tab label="Lessons">
                <div class="lessonContainer p-3">
                  <h3 class="mb-4">Lessons</h3>
                  <ul class="lessonList p-0">
                    <li class="lessonItem d-flex align-items-start gap-5" *ngFor="let item of genrelist.courses_list">
                      <img [src]="item.thumbnail_urls" [alt]="item.thumbnail" />
                      <div>
                        <div class="d-flex align-items-center justify-content-between">
                          <h4 class="mb-3">{{ item.title }}</h4>
                          <span>27 min</span>
                        </div>
                        <p>
                          {{ item.description }}
                        </p>
                      </div>
                    </li>
                  </ul>
                </div>
              </mat-tab>
              <mat-tab label="FAQ">
                <div class="faqContainer p-3">
                  <h3>FAQ</h3>
                  <!-- expansion panel goes here -->
                  <div *ngFor="let item of faqList; let i = index">
                    <div class="accordion-item">
                      <div class="accordion-header" (click)="toggleAccordion(i)">
                        <b>{{ item.question }}</b>
                      </div>
                      <div class="accordion-body" [ngClass]="{ active: activeIndex === i }">
                        {{ item.answer }}
                      </div>
                    </div>
                  </div>
                </div>
              </mat-tab>
            </mat-tab-group>
          </div>
        </div>
        <div>
          <div class="descriptionCard genreCard">
            <h3>All Courses</h3>
            <ul class="">
              <li class="d-flex flex-row gap-2 detailTitle point listItem"
                *ngFor="let genre of allgenrelist; let i = index" routerLink="/genre/genre-details/{{ genre.id }}">
                <a class="d-flex gap-2 genreList">
                  <div class="genreImg">
                    <img loading="lazy" [src]="getImage(genre.name)" [alt]="genre.name" class="img" />
                  </div>
                  <div style="color: black">{{ genre.name }}</div>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="includesContainer">
        <h3 class="mb-4">Includes</h3>
        <ul class="includesList p-0">
          <li class="includeItem d-flex align-items-center gap-2" *ngFor="let item of genrelist.includes">
            <img [src]="item.icon" [alt]="item.title || 'Feature Icon'" />
            <p class="mb-0">{{ item.name }}</p>
          </li>
        </ul>
      </div>
      <h3 class="mb-4 mt-4">Why People Love VIRSA?</h3>
      <div class="d-flex vWork gap-4 mb-3">
        <div class="descriptionCard d-flex flex-column align-items-center">
          <img class="vWorkicon" src="assets/images/icons/ic-5.png" alt="" />
          <h5 class="cardTitile">World Class Masteros and Teachers</h5>
        </div>
        <div class="descriptionCard d-flex flex-column align-items-center">
          <h5 class="cardTitile">Personalized and Interactive 1-on-1 Class</h5>
          <img class="vWorkicon" src="assets/images/icons/ic-6.png" alt="" />
        </div>
        <div class="descriptionCard d-flex flex-column align-items-center">
          <img class="vWorkicon" src="assets/images/icons/ic-7.png" alt="" />
          <h5 class="cardTitile">Course Studio that amplifies Learning</h5>
        </div>
        <div class="descriptionCard d-flex flex-column align-items-center">
          <h5 class="cardTitile">Access to Global Creative Community</h5>
          <img class="vWorkicon" src="assets/images/icons/ic-8.png" alt="" />
        </div>
        <div class="descriptionCard d-flex flex-column align-items-center">
          <img class="vWorkicon" src="assets/images/icons/ic-9.png" alt="" />
          <h5 class="cardTitile">Pay as You Go to Classes at a Time</h5>
        </div>
      </div>
    </div>
  </div>
</section>